var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-w-full"},[_c('div',{staticClass:"board-avonale"},_vm._l((_vm.quantity),function(i){return _c('av-skeleton-card',{key:i})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }